/* Livrinhos do Brasil — interações do tema */
(function () {
  "use strict";

  var CFG = window.LIVRINHOS || {};
  var money = function (cents) {
    try {
      return (cents / 100).toLocaleString("pt-BR", {
        style: "currency",
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR"
      });
    } catch (e) {
      return "€ " + (cents / 100).toFixed(2).replace(".", ",");
    }
  };

  var esc = function (s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  };

  /* Plano de assinatura + propriedades do item (faixa etária, frequência...) */
  function itemMeta(item) {
    var parts = [];
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      parts.push(item.selling_plan_allocation.selling_plan.name);
    }
    var props = item.properties || {};
    Object.keys(props).forEach(function (k) {
      var v = props[k];
      if (v == null || v === "" || k.charAt(0) === "_") return;
      parts.push(k + ": " + v);
    });
    return parts;
  }

  /* ---------- Google Ads ---------- */
  var GA = CFG.googleAds || null;
  function gtagEvent(name, params) {
    if (typeof window.gtag === "function") window.gtag("event", name, params || {});
  }
  function trackAddToCart(item) {
    if (!GA) return;
    var value = ((item && item.final_line_price) || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
    // Evento padrão (útil para remarketing/audiências)
    gtagEvent("add_to_cart", {
      currency: currency,
      value: value,
      items: [{ item_id: item && item.product_id, item_name: item && item.product_title, price: ((item && item.final_price) || 0) / 100, quantity: (item && item.quantity) || 1 }]
    });
    // Conversão "Adicionar ao carrinho" (se o rótulo estiver configurado)
    if (GA.addToCartLabel) {
      gtagEvent("conversion", { send_to: GA.id + "/" + GA.addToCartLabel, value: value, currency: currency });
    }
  }

  /* ---------- Toast ---------- */
  function toast(msg) {
    var stack = document.getElementById("toast-stack");
    if (!stack) return;
    var el = document.createElement("div");
    el.className = "toast";
    el.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>' +
      "<span>" + msg + "</span>";
    stack.appendChild(el);
    setTimeout(function () {
      el.classList.add("out");
      setTimeout(function () { el.remove(); }, 350);
    }, 2600);
  }

  /* ---------- Overlay util ---------- */
  var overlay = document.createElement("div");
  overlay.className = "overlay";
  document.body.appendChild(overlay);
  function showOverlay(on) { overlay.classList.toggle("show", on); }
  function syncScrollLock() {
    var locked =
      (cartDrawerEl && cartDrawerEl.classList.contains("open")) ||
      (mobileMenu && mobileMenu.classList.contains("open"));
    document.body.style.overflow = locked ? "hidden" : "";
  }

  /* ---------- Menu mobile ---------- */
  var menuToggle = document.querySelector(".menu-toggle");
  var mobileMenu = document.querySelector(".mobile-menu");
  if (menuToggle && mobileMenu) {
    var closeMenuBtn = mobileMenu.querySelector(".mobile-menu__close");
    var menuLastFocus = null;
    function toggleMenu(open) {
      mobileMenu.classList.toggle("open", open);
      showOverlay(open || (cartDrawerEl && cartDrawerEl.classList.contains("open")));
      if (open) closeCartDrawer();
      syncScrollLock();
      menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) {
        menuLastFocus = document.activeElement;
        if (closeMenuBtn) closeMenuBtn.focus();
      } else if (menuLastFocus) {
        menuLastFocus.focus();
        menuLastFocus = null;
      }
    }
    menuToggle.addEventListener("click", function () { toggleMenu(true); });
    if (closeMenuBtn) closeMenuBtn.addEventListener("click", function () { toggleMenu(false); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && mobileMenu.classList.contains("open")) toggleMenu(false);
    });
  }

  /* ---------- Cestinho ---------- */
  var cartDrawerEl = document.querySelector(".cart-drawer");
  var cartLastFocus = null;
  function setCartToggles(open) {
    document.querySelectorAll("[data-cart-open]").forEach(function (b) {
      b.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }
  function openCartDrawer() {
    if (!cartDrawerEl) {
      window.location.href = CFG.routes.cart;
      return;
    }
    cartLastFocus = document.activeElement;
    cartDrawerEl.classList.add("open");
    showOverlay(true);
    syncScrollLock();
    setCartToggles(true);
    var closeBtn = cartDrawerEl.querySelector("[data-cart-close]");
    if (closeBtn) closeBtn.focus();
    refreshCart();
  }
  function closeCartDrawer() {
    if (!cartDrawerEl) return;
    var wasOpen = cartDrawerEl.classList.contains("open");
    cartDrawerEl.classList.remove("open");
    showOverlay(false);
    syncScrollLock();
    setCartToggles(false);
    if (wasOpen && cartLastFocus) {
      cartLastFocus.focus();
      cartLastFocus = null;
    }
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && cartDrawerEl && cartDrawerEl.classList.contains("open")) closeCartDrawer();
  });

  overlay.addEventListener("click", function () {
    closeCartDrawer();
    if (mobileMenu) mobileMenu.classList.remove("open");
    showOverlay(false);
    syncScrollLock();
  });

  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-cart-open]");
    if (t) {
      e.preventDefault();
      if (CFG.cartDrawer) openCartDrawer();
      else window.location.href = CFG.routes.cart;
    }
    var c = e.target.closest("[data-cart-close]");
    if (c) closeCartDrawer();
    // Finalizar compra (drawer ou página do carrinho)
    var checkout = e.target.closest("a[href$='/checkout'], a[href*='/checkout?']");
    if (checkout && GA) {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          gtagEvent("begin_checkout", {
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR",
            value: (cart.total_price || 0) / 100,
            items: (cart.items || []).map(function (i) {
              return { item_id: i.product_id, item_name: i.product_title, price: (i.final_price || 0) / 100, quantity: i.quantity };
            })
          });
        })
        .catch(function () {});
    }
  });

  function updateCount(count) {
    document.querySelectorAll(".cart-count").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCart(cart) {
    if (!cartDrawerEl) return;
    if (!cart || !Array.isArray(cart.items)) return; // resposta de erro
    updateCount(cart.item_count);
    var itemsEl = cartDrawerEl.querySelector(".cart-drawer__items");
    var emptyEl = cartDrawerEl.querySelector(".cart-drawer__empty");
    var footEl = cartDrawerEl.querySelector(".cart-drawer__foot");
    var progEl = cartDrawerEl.querySelector(".shipping-progress");

    if (cart.item_count === 0) {
      if (itemsEl) itemsEl.hidden = true;
      if (footEl) footEl.hidden = true;
      if (progEl) progEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (itemsEl) itemsEl.hidden = false;
    if (footEl) footEl.hidden = false;
    if (progEl) progEl.hidden = false;

    // Barra de frete grátis
    if (progEl) {
      var threshold = CFG.freeShippingNl || 6000;
      var euThreshold = CFG.freeShippingEu || 9000;
      var missing = Math.max(0, threshold - cart.total_price);
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      var msgEl = progEl.querySelector("p");
      var isSub = function (item) {
        return item.selling_plan > 0 || !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
      };
      var hasSub = cart.items.some(isSub);
      var allSub = hasSub && cart.items.every(isSub);
      if (CFG.clubTag) {
        msgEl.classList.add("unlocked");
        msgEl.textContent = "Assinatura: frete grátis para este pedido!";
        progEl.querySelector(".shipping-progress__bar").style.width = "100%";
      } else if (allSub) {
        msgEl.classList.add("unlocked");
        msgEl.textContent = "Sua assinatura não paga frete!";
        progEl.querySelector(".shipping-progress__bar").style.width = "100%";
      } else if (missing > 0) {
        msgEl.classList.remove("unlocked");
        msgEl.innerHTML =
          "Faltam <strong>" + money(missing) + "</strong> para frete grátis na Holanda" +
          '<span class="shipping-progress__eu">Resto da Europa: grátis a partir de ' + money(euThreshold) + "</span>";
        progEl.querySelector(".shipping-progress__bar").style.width = pct + "%";
      } else {
        msgEl.classList.add("unlocked");
        msgEl.innerHTML =
          "Você ganhou frete grátis para a Holanda!" +
          '<span class="shipping-progress__eu">Resto da Europa: grátis a partir de ' + money(euThreshold) + "</span>";
        progEl.querySelector(".shipping-progress__bar").style.width = pct + "%";
      }
    }

    // Itens
    if (itemsEl) {
      itemsEl.innerHTML = cart.items
        .map(function (item) {
          var img = item.image
            ? '<img src="' + item.image.replace(/(\.[^.]*)$/, "_240x$1") + '" alt="" loading="lazy">'
            : "";
          var meta = itemMeta(item)
            .map(function (m) { return '<span class="cart-line__meta">' + esc(m) + "</span>"; })
            .join("");
          return (
            '<div class="cart-line" data-key="' + item.key + '">' +
            '<a href="' + item.url + '">' + img + "</a>" +
            '<div class="cart-line__info">' +
            '<a class="cart-line__title" href="' + item.url + '">' + esc(item.product_title) + "</a>" +
            (item.variant_title && item.variant_title !== "Default Title"
              ? '<span class="cart-line__meta">' + esc(item.variant_title) + "</span>"
              : "") +
            meta +
            (item.original_line_price > item.final_line_price
              ? '<span class="cart-line__price"><s>' + money(item.original_line_price) + "</s> " + money(item.final_line_price) + '</span><span class="cart-line__meta">Desconto assinante</span>'
              : '<span class="cart-line__price">' + money(item.final_line_price) + "</span>") +
            '<div class="cart-line__actions">' +
            '<div class="cart-line__qty">' +
            '<button data-qty="' + (item.quantity - 1) + '" aria-label="Diminuir"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 12h14"/></svg></button>' +
            "<span>" + item.quantity + "</span>" +
            '<button data-qty="' + (item.quantity + 1) + '" aria-label="Aumentar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M12 5v14M5 12h14"/></svg></button>' +
            "</div>" +
            '<button class="cart-line__remove" data-qty="0" aria-label="Remover"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6"/></svg></button>' +
            "</div></div></div>"
          );
        })
        .join("");
    }

    var totalEl = cartDrawerEl.querySelector(".cart-drawer__total span:last-child");
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  function refreshCart() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  // Alterar quantidade dentro do drawer
  if (cartDrawerEl) {
    cartDrawerEl.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-qty]");
      if (!btn) return;
      var line = btn.closest(".cart-line");
      if (!line) return;
      fetch(CFG.routes.cartChange + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: line.dataset.key, quantity: parseInt(btn.dataset.qty, 10) })
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body.description || body.message || "Erro ao atualizar");
            return body;
          });
        })
        .then(renderCart)
        .catch(function (err) {
          toast(err.message || "Não foi possível atualizar a quantidade");
          refreshCart();
        });
    });
  }

  // Adicionar ao cestinho (intercepta formulários)
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form[data-add-to-cart]");
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector("[type=submit]");
    if (btn) btn.disabled = true;
    var data = new FormData(form);
    fetch(CFG.routes.cartAdd + ".js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: data
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || "Erro ao adicionar");
          return body;
        });
      })
      .then(function (item) {
        trackAddToCart(item);
        toast("\u201C" + (item.product_title || "Livro") + "\u201D no cestinho!");
        if (CFG.cartDrawer) openCartDrawer();
        else refreshCart();
      })
      .catch(function (err) {
        if (err && err.message) toast(err.message);
        else form.submit();
        refreshCart();
      })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  // Contagem inicial
  refreshCart();

  /* ---------- Vitrines horizontais ---------- */
  document.querySelectorAll(".book-row").forEach(function (row) {
    var track = row.querySelector(".book-row__track");
    if (!track) return;
    row.querySelectorAll("[data-scroll]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        track.scrollBy({ left: parseInt(btn.dataset.scroll, 10) * 480, behavior: "smooth" });
      });
    });
  });

  /* ---------- Carrossel automático de capas do hero ---------- */
  document.querySelectorAll("[data-hero-carousel]").forEach(function (carousel) {
    var track = carousel.querySelector(".hero__carousel-track");
    var covers = carousel.querySelectorAll(".hero__cover");
    var dots = carousel.querySelectorAll(".hero__carousel-dot");
    if (!track || covers.length < 2) return;

    var idx = 0;
    var timer = null;
    var userPaused = false;
    var DELAY = 3500;

    function goTo(i) {
      idx = ((i % covers.length) + covers.length) % covers.length;
      track.scrollTo({ left: covers[idx].offsetLeft - track.offsetLeft - (track.clientWidth - covers[idx].clientWidth) / 2, behavior: "smooth" });
      dots.forEach(function (d, j) { d.classList.toggle("is-active", j === idx); });
    }
    function play() {
      stop();
      timer = setInterval(function () { goTo(idx + 1); }, DELAY);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    carousel.addEventListener("mouseenter", stop);
    carousel.addEventListener("mouseleave", function () { if (!userPaused) play(); });
    carousel.addEventListener("focusin", stop);
    carousel.addEventListener("focusout", function () { if (!userPaused) play(); });
    // Botão de pausa/retomar (WCAG 2.2.2)
    var pauseBtn = carousel.querySelector("[data-carousel-toggle]");
    if (pauseBtn) {
      var iconPause = pauseBtn.querySelector("[data-icon-pause]");
      var iconPlay = pauseBtn.querySelector("[data-icon-play]");
      var paused = false;
      pauseBtn.addEventListener("click", function () {
        paused = !paused;
        userPaused = paused;
        if (paused) stop(); else play();
        pauseBtn.setAttribute("aria-pressed", paused ? "true" : "false");
        pauseBtn.setAttribute("aria-label", paused ? "Retomar carrossel" : "Pausar carrossel");
        if (iconPause) iconPause.hidden = paused;
        if (iconPlay) iconPlay.hidden = !paused;
      });
    }
    // Pausa se a aba perder o foco
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop(); else if (!userPaused) play();
    });
    // Respeita usuários com preferência por menos movimento
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    play();
  });

  /* ---------- Carrossel de capas do Clube ---------- */
  document.querySelectorAll("[data-club-track]").forEach(function (track) {
    var wrap = track.closest(".club-banner__carousel");
    if (!wrap) return;
    wrap.querySelectorAll("[data-club-scroll]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        track.scrollBy({ left: parseInt(btn.dataset.clubScroll, 10) * 280, behavior: "smooth" });
      });
    });
  });

  /* ---------- Carrossel de banners ---------- */
  document.querySelectorAll("[data-banner-carousel]").forEach(function (carousel) {
    var track = carousel.querySelector(".banner-carousel__track");
    var slides = carousel.querySelectorAll(".banner-carousel__slide");
    var dots = carousel.querySelectorAll("[data-dot]");
    if (!track || !slides.length) return;

    function goTo(i) {
      var idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: "smooth" });
    }
    function currentIndex() {
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    carousel.querySelectorAll("[data-scroll]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        goTo(currentIndex() + parseInt(btn.dataset.scroll, 10));
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        var i = parseInt(dot.dataset.dot, 10);
        goTo(i);
        dots.forEach(function (d, j) {
          d.classList.toggle("is-active", j === i);
          if (j === i) d.setAttribute("aria-current", "true");
          else d.removeAttribute("aria-current");
        });
      });
    });
    var scrollTimer;
    track.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var idx = currentIndex();
        dots.forEach(function (d, i) {
          d.classList.toggle("is-active", i === idx);
          if (i === idx) d.setAttribute("aria-current", "true");
          else d.removeAttribute("aria-current");
        });
      }, 80);
    }, { passive: true });
  });

  /* ---------- Dropdowns do header: aria-expanded ---------- */
  document.querySelectorAll(".nav-item").forEach(function (item) {
    var btn = item.querySelector("[data-nav-dropdown]");
    if (!btn) return;
    function setExp(on) { btn.setAttribute("aria-expanded", on ? "true" : "false"); }
    item.addEventListener("mouseenter", function () { setExp(true); });
    item.addEventListener("mouseleave", function () { setExp(false); });
    item.addEventListener("focusin", function () { setExp(true); });
    item.addEventListener("focusout", function () {
      if (!item.contains(document.activeElement)) setExp(false);
    });
  });

  /* ---------- Quantidade na página de produto ---------- */
  document.querySelectorAll(".qty-selector").forEach(function (sel) {
    var input = sel.querySelector("input");
    sel.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var v = parseInt(input.value, 10) + parseInt(btn.dataset.step, 10);
        v = Math.max(1, v);
        var max = parseInt(input.max, 10);
        if (!isNaN(max)) v = Math.min(v, max);
        input.value = v;
      });
    });
  });

  /* ---------- Filtros de coleção: submit automático ---------- */
  document.querySelectorAll("[data-filter-form] input, [data-filter-form] select").forEach(function (input) {
    input.addEventListener("change", function () {
      input.closest("form").submit();
    });
  });

  /* ---------- Filtro de preço: disponibilidade já é garantida
     pelo redirect da própria seção (sem JS extra aqui) ---------- */

  /* ---------- Botão de filtros (mobile) ---------- */
  document.querySelectorAll("[data-filters-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var det = document.getElementById(btn.getAttribute("aria-controls"));
      if (!det) return;
      det.open = !det.open;
      btn.setAttribute("aria-expanded", det.open ? "true" : "false");
    });
  });

  // No desktop os filtros começam abertos; no mobile, fechados.
  var filtersDet = document.getElementById("collection-filters");
  var filtersBtn = document.querySelector("[data-filters-toggle]");
  if (filtersDet) {
    var DESKTOP_FILTERS = 1024;
    var openNow = window.innerWidth >= DESKTOP_FILTERS;
    filtersDet.open = openNow;
    if (filtersBtn) filtersBtn.setAttribute("aria-expanded", openNow ? "true" : "false");
  }

  /* ---------- Seletor de variantes + faixas etárias (página de produto) ---------- */
  var productForm = document.querySelector("[data-product-form]");
  if (productForm) {
    var variantsJson = document.querySelector("[data-variants-json]");
    var variants = [];
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) {}
    var idInput = productForm.querySelector("[data-variant-id]");
    var priceValue = document.querySelector("[data-price-value]");
    var ageWrap = document.querySelector("[data-age-selectors]");

    function booksInVariant(title) {
      var m = title.match(/(\d+)/);
      return m ? Math.min(3, Math.max(1, parseInt(m[1], 10))) : 1;
    }

    function syncAgeSelectors(variant) {
      if (!ageWrap || !variant) return;
      var n = booksInVariant(variant.title);
      ageWrap.querySelectorAll("[data-age-item]").forEach(function (item) {
        var show = parseInt(item.dataset.ageItem, 10) <= n;
        item.hidden = !show;
        var sel = item.querySelector("select");
        if (sel) sel.required = show;
      });
    }

    function syncStockLimit(variant) {
      var qtyInput = productForm.querySelector(".qty-selector input");
      if (!qtyInput || !variant) return;
      if (variant.tracked && variant.inventory > 0) {
        qtyInput.max = variant.inventory;
        if (parseInt(qtyInput.value, 10) > variant.inventory) qtyInput.value = variant.inventory;
      } else {
        qtyInput.removeAttribute("max");
      }
    }

    /* Resumo da escolha na barra fixa: "2 livrinhos · Mensal" */
    var stickyTitle = document.querySelector("[data-sticky-title]");
    function updateStickyTitle() {
      if (!stickyTitle) return;
      var parts = [];
      productForm.querySelectorAll(".variant-picker__group").forEach(function (group) {
        var checked = group.querySelector("input:checked");
        if (checked) parts.push(checked.value);
      });
      var freq = productForm.querySelector('input[name="selling_plan"]:checked');
      if (freq && freq.nextElementSibling) parts.push(freq.nextElementSibling.textContent.trim());
      stickyTitle.textContent = parts.length ? parts.join(" · ") : stickyTitle.getAttribute("data-title") || "";
    }

    /* Nota de cobrança dinâmica: "1.ª cobrança hoje: €45,00 · Depois, a cada 2 meses (próxima em 11 dez) · Cancele quando quiser" */
    var MONTHS_PT = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
    function addMonths(date, n) {
      var d = new Date(date.getTime());
      var day = d.getDate();
      d.setDate(1);
      d.setMonth(d.getMonth() + n);
      var lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
      d.setDate(Math.min(day, lastDay));
      return d;
    }
    var billingText = document.querySelector("[data-billing-note-text]");
    function updateBillingNote() {
      if (!billingText) return;
      var freq = productForm.querySelector('input[name="selling_plan"]:checked');
      var months = freq ? parseInt(freq.getAttribute("data-interval"), 10) : 0;
      var variant = variants.find(function (v) { return v.id === parseInt(idInput.value, 10); });
      if (!variant || !months) return;
      var first = "1.ª cobrança hoje: " + money(variant.price);
      var tail = "Cancele quando quiser";
      var renewal;
      if (months === 1) {
        renewal = "depois, todo mês na mesma data";
      } else {
        var next = addMonths(new Date(), months);
        renewal = "depois, a cada " + months + " meses (próxima em " + next.getDate() + " " + MONTHS_PT[next.getMonth()] + ")";
      }
      billingText.textContent = first + " · " + renewal + " · " + tail;
    }

    productForm.querySelectorAll(".variant-picker input[type=radio]").forEach(function (radio) {
      radio.addEventListener("change", function () {
        var chosen = [];
        productForm.querySelectorAll(".variant-picker__group").forEach(function (group) {
          var checked = group.querySelector("input:checked");
          if (checked) chosen.push(checked.value);
        });
        var variant = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceValue) priceValue.textContent = money(variant.price);
        var stickyPrice = document.querySelector("[data-sticky-price]");
        if (stickyPrice) stickyPrice.textContent = money(variant.price);
        var submitBtn = productForm.querySelector("[type=submit]");
        if (submitBtn) submitBtn.disabled = !variant.available;
        syncStockLimit(variant);
        syncAgeSelectors(variant);
        updateStickyTitle();
        updateBillingNote();
      });
    });

    productForm.querySelectorAll('input[name="selling_plan"]').forEach(function (radio) {
      radio.addEventListener("change", function () {
        updateStickyTitle();
        updateBillingNote();
      });
    });
    updateStickyTitle();
    updateBillingNote();

    // Estado inicial das faixas etárias
    var initialChecked = productForm.querySelector(".variant-picker input:checked");
    if (initialChecked && variants.length) {
      var v0 = variants.find(function (v) { return v.id === parseInt(idInput.value, 10); });
      if (v0) { syncAgeSelectors(v0); syncStockLimit(v0); }
    }

    /* ---------- Barra fixa de compra (mobile) ---------- */
    var stickyBar = document.querySelector("[data-sticky-atc]");
    var stickyBtn = document.querySelector("[data-sticky-submit]");
    if (stickyBar && stickyBtn) {
      var mainBtn = productForm.querySelector("[type=submit]");
      if ("IntersectionObserver" in window && mainBtn) {
        var io = new IntersectionObserver(function (entries) {
          var show = !entries[0].isIntersecting;
          stickyBar.classList.toggle("is-visible", show);
          document.body.classList.toggle("has-sticky-atc", show);
        }, { rootMargin: "-80px 0px 0px 0px" });
        io.observe(mainBtn);
      }
      stickyBtn.addEventListener("click", function () {
        productForm.requestSubmit();
      });
    }
  }

  /* ---------- Miniaturas na página de produto ----------
     (agora abrem o lightbox; este bloco ficou obsoleto) */

  /* ---------- Favorito (visual) ---------- */
  document.addEventListener("click", function (e) {
    var fav = e.target.closest(".fav-btn");
    if (!fav) return;
    fav.classList.toggle("active");
    toast(fav.classList.contains("active") ? "Salvo nos favoritos" : "Removido dos favoritos");
  });
})();

/* ===== Galeria da página de produto =====
   Miniaturas trocam a mídia principal; o lightbox abre só ao clicar
   na mídia principal, já na posição do item exibido. */
(function () {
  var mediaRoot = document.querySelector('[data-product-media]');
  if (!mediaRoot) return;
  var dataEl = mediaRoot.querySelector('[data-media-json]');
  if (!dataEl) return;

  var media;
  try { media = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!media || !media.length) return;

  var mainSlot = mediaRoot.querySelector('[data-media-main]');
  var thumbs = Array.prototype.slice.call(mediaRoot.querySelectorAll('[data-media-select]'));
  var lightbox = mediaRoot.querySelector('[data-lightbox]');
  var stage = lightbox ? lightbox.querySelector('[data-lightbox-stage]') : null;
  var counter = lightbox ? lightbox.querySelector('[data-lightbox-counter]') : null;
  var prev = lightbox ? lightbox.querySelector('[data-lightbox-prev]') : null;
  var next = lightbox ? lightbox.querySelector('[data-lightbox-next]') : null;
  var lastFocus = null;
  var current = 0;
  var lightboxOpen = null;

  function embedUrl(m) {
    if (!m.embed) return null;
    if (m.host === 'youtube') {
      var id = m.embed.split('/').pop().split('?')[0];
      return 'https://www.youtube.com/embed/' + id;
    }
    if (m.host === 'vimeo') {
      var vid = m.embed.split('/').pop().split('?')[0];
      return 'https://player.vimeo.com/video/' + vid;
    }
    return m.embed;
  }

  function buildMediaEl(m, full) {
    if (m.type === 'video' && m.videoSources && m.videoSources.length) {
      var v = document.createElement('video');
      v.controls = true;
      v.preload = 'metadata';
      if (m.preview) v.poster = m.preview;
      m.videoSources.forEach(function (s) {
        if (!s || !s.url) return;
        var src = document.createElement('source');
        src.src = s.url;
        if (s.mime) src.type = s.mime;
        v.appendChild(src);
      });
      return v;
    }
    if (m.type === 'external_video') {
      var iframe = document.createElement('iframe');
      iframe.src = embedUrl(m);
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      return iframe;
    }
    var img = document.createElement('img');
    img.src = full ? (m.full || m.src) : m.src;
    img.alt = m.alt || '';
    return img;
  }

  function stopStageMedia() {
    if (!stage) return;
    stage.querySelectorAll('video').forEach(function (v) { v.pause(); });
    stage.querySelectorAll('iframe').forEach(function (f) {
      var s = f.getAttribute('src');
      if (s) f.setAttribute('src', s); // reinicia vídeo externo
    });
  }

  function selectMedia(index, fromThumb) {
    current = (index + media.length) % media.length;
    if (mainSlot) {
      mainSlot.querySelectorAll('video').forEach(function (v) { v.pause(); });
      mainSlot.innerHTML = '';
      mainSlot.appendChild(buildMediaEl(media[current], false));
    }
    var frame = mediaRoot.querySelector('.product-media__frame');
    if (frame) {
      var isVid = media[current].type === 'video' || media[current].type === 'external_video';
      frame.classList.toggle('product-media__frame--video', isVid);
    }
    thumbs.forEach(function (b, i) {
      b.classList.toggle('active', i === current);
      if (i === current) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });
  }

  // Clique na área principal: em vídeo, dá play/pausa (o botão central
  // some quando o vídeo começa, e os controles nativos assumem).
  if (mainSlot) {
    mainSlot.addEventListener('click', function (e) {
      var v = mainSlot.querySelector('video');
      if (!v) return;
      if (e.target === v || e.target.closest('.product-media__playbtn')) {
        if (v.paused) { v.play(); } else { v.pause(); }
      }
    });
    mainSlot.addEventListener('play', function (e) {
      if (e.target.tagName === 'VIDEO') mainSlot.classList.add('is-playing');
    }, true);
    mainSlot.addEventListener('pause', function (e) {
      if (e.target.tagName === 'VIDEO') mainSlot.classList.remove('is-playing');
    }, true);
    mainSlot.addEventListener('ended', function (e) {
      if (e.target.tagName === 'VIDEO') mainSlot.classList.remove('is-playing');
    }, true);
  }

  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.getAttribute('data-media-select'), 10) || 0;
      // Miniatura sempre só troca a área principal — inclusive vídeo,
      // que toca inline. Tela cheia fica no player nativo do vídeo.
      selectMedia(idx, true);
    });
  });

  if (lightbox && stage) {
    function show(index) {
      current = (index + media.length) % media.length;
      stage.innerHTML = '';
      var item = document.createElement('div');
      item.className = 'lightbox__item';
      item.appendChild(buildMediaEl(media[current], true));
      stage.appendChild(item);
      if (counter) counter.textContent = (current + 1) + ' / ' + media.length;
    }

    lightboxOpen = function () {
      lastFocus = document.activeElement;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      show(current); // abre no item que está na área principal
      var closeBtn = lightbox.querySelector('[data-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    };
    var open = lightboxOpen;

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      stopStageMedia();
      stage.innerHTML = '';
      if (lastFocus) lastFocus.focus();
    }

    var openBtn = mediaRoot.querySelector('[data-lightbox-open]');
    if (openBtn) openBtn.addEventListener('click', open);

    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', close);
    if (prev) prev.addEventListener('click', function () { stopStageMedia(); show(current - 1); });
    if (next) next.addEventListener('click', function () { stopStageMedia(); show(current + 1); });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft' && prev) { stopStageMedia(); show(current - 1); }
      else if (e.key === 'ArrowRight' && next) { stopStageMedia(); show(current + 1); }
    });

    var touchX = null;
    lightbox.addEventListener('touchstart', function (e) {
      touchX = e.changedTouches[0].clientX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 50) {
        stopStageMedia();
        if (dx > 0 && prev) show(current - 1);
        else if (dx < 0 && next) show(current + 1);
      }
      touchX = null;
    }, { passive: true });
  }
})();
